<ng-container *ngSubscribe="fields as fields">
  <field [field]="fields.amount" class="medium"></field>
  <field [field]="fields.currencies_id" class="medium"></field>
  <field [field]="fields.requested_at" class="medium"></field>
  <field [field]="fields.products_id" class="medium"></field>
  <field [field]="fields.detail" class="medium"></field>
  <field [field]="fields.comments" class="medium"></field>
</ng-container>
